import { GameCollectionRecordBlock } from './GameCollectionRecordBlock'

type Props = {
  totalCount: number
  typeCount: number
  maxCount: number
  recordBlockBgColor?: string
  recordBlockTextColor?: string
}

export function GameCollectionRecordBlockList(props: Props) {
  const { totalCount, typeCount, maxCount, recordBlockBgColor = '#323232', recordBlockTextColor = '#E0D07D' } = props

  return (
    <div className="mx-auto grid w-[294px] grid-cols-3 gap-3">
      <GameCollectionRecordBlock text="収集数" count={totalCount} recordBlockBgColor={recordBlockBgColor} recordBlockTextColor={recordBlockTextColor} />
      <GameCollectionRecordBlock text="種類数" count={typeCount} recordBlockBgColor={recordBlockBgColor} recordBlockTextColor={recordBlockTextColor} />
      <GameCollectionRecordBlock text="最大数" count={maxCount} recordBlockBgColor={recordBlockBgColor} recordBlockTextColor={recordBlockTextColor} />
    </div>
  )
}
